var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 36,
    viewBox: "0 0 204 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M204 36H0L204 0V36Z",
    fill: "url(#paint0_linear_5492_11377)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5492_11377",
    x1: 1.73564e-7,
    y1: 3.4512,
    x2: 208.898,
    y2: -1.37551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F64738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.581092,
    stopColor: "#FFAD33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72DE6B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientIc);
export default __webpack_public_path__ + "static/media/gradient_ic.1d85fff6de8c05e945c48291738f1c4f.svg";
export { ForwardRef as ReactComponent };